module.exports = __webpack_public_path__ + "static/img/girl--small.9a0c610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bathroom/girl--small.svg
// module id = 147
// module chunks = 2